module.exports = __webpack_public_path__ + "career-icon-parental.1xa0TbiT.svg";